import React, { Component } from "react";
import ReactTooltip from "react-tooltip";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core styles
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme
import "./ag-theme-ela.css";
import DollarIcon from "../images/dollar-icon.png";

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: "1px solid #ccc", // Adds a light gray divider
  },
};

const accountsReceivableColumns = [
  { headerName: "JobId", field: "jobNum", width: 65 },
  { headerName: "Claimant #", field: "claimantELANum", width: 105 },
  { headerName: "Action", field: "actionCode", width: 30 },
  {
    headerName: "Notes",
    field: "notes",
    cellRenderer: "acctRecNotesCellRenderer",
    width: 20,
  },
  { headerName: "Transaction Date", field: "transactionDate", width: 125 },
  { headerName: "Check Date", field: "checkDate", width: 125 },
  { headerName: "Check Number", field: "checkNumber", width: 80 },
  { headerName: "Transfer From", field: "transferFrom", width: 80 },
  { headerName: "Transfer To", field: "transferTo", width: 80 },
  { headerName: "Amount", field: "amount", width: 80 },
  { headerName: "Balance", field: "balance", width: 80 },
  { headerName: "Claimant", field: "claimantName", width: 150 },
];

export class AccountsReceivableTableDefault extends Component {
  static displayName = AccountsReceivableTableDefault.name;

  constructor(props) {
    super(props);
    this.state = {
      columnWidths: accountsReceivableColumns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
      isResizing: -1,
      clickCount: 0,
    };
    this.previousSelection = [];
    // Bind methods
    this.onColumnResized = this.onColumnResized.bind(this);
    this.viewAcctRecNotes = this.viewAcctRecNotes.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  componentWillUnmount() {
    clearTimeout(this.clickTimer);
  }

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        ".ag-header-cell-text"
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        // Ensure that you have access to the clientHeight property correctly
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      // Adding some padding or extra space if necessary
      maxHeight += 10; // Adjust this value based on your CSS and padding needs

      // Directly set the new header height
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        // Call adjustHeaderHeight after state update to ensure it uses the latest widths
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  viewAcctRecNotes = (data) => {
    if (this.props.viewAcctRecNotes) {
      this.props.viewAcctRecNotes(data);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: accountsReceivableColumns,
      rowData: this.props.acctRecList,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        setModal: this.props.setModal,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {
        acctRecNotesCellRenderer: acctRecNotesCellRenderer,
      },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      suppressRowClickSelection: true,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: "100%",
          height: "600px",
        }}
      >
        <AgGridReact
          {...gridOptions}
          onGridReady={this.onGridReady}
          rowSelection={"multiple"}
        />
      </div>
    );
  }
}

class acctRecNotesCellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    if (
      context &&
      context.componentParent &&
      context.componentParent.viewAcctRecNotes
    ) {
      context.componentParent.viewAcctRecNotes(data);
    }
  };

  render() {
    return (
      <img
        src={DollarIcon}
        style={{ width: "16px", height: "16px", cursor: "pointer" }}
        alt="Notes"
        onClick={this.handleClick}
      />
    );
  }
}
